import React from 'react';
import { UserRole } from '../../Enums/UserRole';
import { CandidateCardForManager } from './CandidateCardForManager';
import { CandidateCardForNotAuthorized } from './CandidateCardForNotAuthorized';
import { Candidate } from '../../types';

type CandidateCardProps = {
    candidate: Candidate,
    role: string
}

export function CandidateCard({ candidate, role }: CandidateCardProps) {
    if (role == UserRole.Manager)
        return (
            <CandidateCardForManager candidate={candidate}/>
        )
    return (
        <CandidateCardForNotAuthorized candidate={candidate}/>
    )
}